<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="col-9">
          <h1>Profile Page</h1>
          <ul class="nav nav-pills nav-fill">
            <li class="nav-item">
              <a :class="{'nav-link': true, 'active': showPackages}"
                 @click="viewPackages()"
                 href="javascript:void(0);">
                Packages
              </a>
            </li>
            <li class="nav-item">
              <a :class="{'nav-link': true, 'active': !showPackages}"
                 @click="viewOrganizations()"
                 href="javascript:void(0);">
                Organizations
              </a>
            </li>
          </ul>
          <beast-packages-list v-show="showPackages"
                               :url="packageUrl"
                               :package-search="false"
                               v-on:keywordSearch="updateSearch"/>
          <beast-organizations-list v-show="!showPackages"
                                    :url="organizationsUrl"/>
        </div>
        <div class="col-3">
          <ul class="beast-list">
            <li>
              <img :src="`https://www.gravatar.com/avatar/${user.gravatarHash}?s=200`"/>
            </li>
            <li class="beast-userbar-title" v-text="user.username"></li>
            <li class="beast-list-separator" v-text="user.fullName"></li>
            <li class="beast-list-separator" v-if="isCurrentUserProfile">
              <router-link :to="`/organization/new`">Create Organization</router-link>
            </li>
            <li class="beast-list-separator" v-if="isCurrentUserProfile">
              <router-link :to="`/profile/${this.me.username}/edit`">Edit profile</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<script>
import BeastHeader from "../../components/header/BeastHeader.vue";
import BeastFooter from "../../components/footer/BeastFooter.vue";
import BeastPackagesList from "../../components/packages/BeastPackagesList.vue";
import BeastOrganizationsList from "../../components/packages/BeastOrganizationsList.vue";

export default {
  components: {
    BeastOrganizationsList, BeastPackagesList, BeastFooter, BeastHeader
  },
  props: {
    username: {
      type: String,
      default: ""
    }
  },
  computed: {
    profileUrl() {
      if (this.username === null || this.username === undefined || this.username === "") {
        return "/profile";
      }
      return `/profile/${this.username}`;
    },
    packageUrl() {
      return `${this.profileUrl}/packages`;
    },
    organizationsUrl() {
      return `${this.profileUrl}/organizations`;
    },
    isCurrentUserProfile() {
      return this.$auth.check() && this.user.username === this.me.username;
    }
  },
  data() {
    return {
      me: {
        username: ""
      },
      user: {
        gravatarHash: "",
        username: "",
        fullName: ""
      },
      showPackages: true,
    };
  },
  watch: {
    username() {
      this._readUserData();
    }
  },
  methods: {
    async _readUserData() {
      try {
        const response = await this.axios.get(this.profileUrl);

        Object.assign(this.user, response.data);

        this.setTitle(this.user.username);
      } catch (error) {
        const responseStatus = error.response ? error.response.status : 500;
        if (responseStatus === 404 || responseStatus === 401) {
          this.$router.replace({ name: "not-found" });
        }
      }
    },
    updateSearch(query) {
      this.$router.replace({
        name: "search",
        query: {
          query,
          page: 1
        }
      });
    },
    viewPackages() {
      this.showPackages = true;
    },
    viewOrganizations() {
      this.showPackages = false;
    },
  },

  async beforeMount() {
    this.me = await this.$auth.user();
    await this._readUserData();
  }
};
</script>
<style scoped lang="scss">
  .beast-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .beast-list-separator {
    border-top: 1px solid #b4b4b4;
    padding-top: 5px;
    margin-top: 5px;
  }

  .beast-userbar-title {
    font-size: 30px;
  }

  h1 {
    text-transform: uppercase;
  }

  .nav {
    margin-bottom: 10px;
    .nav-link {
      color: $beast-dark-gray;
      border-bottom: 1px solid $beast-light-gray;
      border-radius: 5px 5px 0 0;
    }

    .nav-link:hover {
      background-color: $beast-very-light-gray;
    }

    .active, .active:hover {
      background-color: $beast-green;
      color: $beast-white;
      border: none;
    }
  }
</style>
